module.exports = __webpack_public_path__ + "img/departing.38215e32.svg";